import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["number"];

  connect() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    this.numberTargets.forEach((el) => {
      this.observer.observe(el);
    });
  }

  disconnect() {
    this.observer.disconnect();
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const el = entry.target;

        const final = el.dataset.final;
        if (!final) return;

        const animateClass = `animate--${final}`;

        el.classList.remove(animateClass);
        void el.offsetWidth; // reflow
        el.classList.add(animateClass);
      }
    });
  }
}
